export const FormError = {
  baseStyle: () => ({
    text: {
      fontSize: '12px',
      color: 'portlandOrange',
      marginTop: '2px',
    },
  }),
};
